import React from "react";
import CategoryPage from "./CategoryPage";

export default function PumpAccessoriesPage() {
  return (
    <CategoryPage
      categoryMatch="pump accessories"
      title="Pump Accessories - Spare Parts"
      subtitle="Genuine spare parts and accessories for industrial and submersible pumps."
      searchPlaceholder="Search accessories..."
    />
  );
}